// Author yujiabei
// Date 2022-01-25 20:14:35

class EmAdmFactoryModelEafm {
constructor({
        id = null,
        name = '',
        seq = '',
        parentId = '',
        eafmIdEafmt = '',
        eafmtName = '',
        eafmExAttrA = '',
        eafmExAttrB = '',
        eafmExAttrC = '',
        eafmExAttrD = '',
        eafmExAttrE = '',
        eafmRemark = '',
        eafmIdExternal = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.seq = seq;
    this.parentId = parentId;
    this.eafmIdEafmt = eafmIdEafmt;
    this.eafmtName = eafmtName;
    this.eafmExAttrA = eafmExAttrA;
    this.eafmExAttrB = eafmExAttrB;
    this.eafmExAttrC = eafmExAttrC;
    this.eafmExAttrD = eafmExAttrD;
    this.eafmExAttrE = eafmExAttrE;
    this.eafmRemark = eafmRemark;
    this.eafmIdExternal = eafmIdExternal;
}
}

function newEntity() {
return new EmAdmFactoryModelEafm();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.parentId',
        sortable: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAdmFactoryModelEafm'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmtName',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.eafmtName',
        sortable: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAdmFactoryModelTypeEafmt'
        }
        },
        {
        key: 'eafmExAttrA',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.eafmExAttrA',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmExAttrB',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.eafmExAttrB',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmExAttrC',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.eafmExAttrC',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmExAttrD',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.eafmExAttrD',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmExAttrE',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.eafmExAttrE',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eafmRemark',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.eafmRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'eafmIdExternal',
        label: 'label.em.admin.emAdmFactoryModelEafm.grid.eafmIdExternal',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    nameFilter : '',
    levelFilter : '',
    seqFilter : '',
    parentIdFilter : '',
    nodeCodeFilter : '',
    eafmIdEafmtInFilter : [],
    eafmExAttrAFilter : '',
    eafmExAttrBFilter : '',
    eafmExAttrCFilter : '',
    eafmExAttrDFilter : '',
    eafmExAttrEFilter : '',
    eafmIdExternalFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAdmFactoryModelEafm.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.em.admin.emAdmFactoryModelEafm.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.em.admin.emAdmFactoryModelEafm.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAdmFactoryModelEafm'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eafmIdEafmtInFilter',
        label: 'label.em.admin.emAdmFactoryModelEafm.filter.eafmIdEafmtIn',
        disabled: false,
        form: {
        type: 'entitySelectMultiple'
            ,entity: 'emAdmFactoryModelTypeEafmt'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.emAdmFactoryModelEafm.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAdmFactoryModelEafm.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.emAdmFactoryModelEafm.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAdmFactoryModelEafm'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eafmtName',
        label: 'label.em.admin.emAdmFactoryModelEafm.entity.eafmtName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAdmFactoryModelTypeEafmt'
            ,correspondingField: 'eafmtName'
            ,fieldsBindingByEntityModalSelected: '{"eafmIdEafmt":"id"}'
                }
        },
        {
        key: 'eafmExAttrA',
        label: 'label.em.admin.emAdmFactoryModelEafm.entity.eafmExAttrA',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eafmRemark',
        label: 'label.em.admin.emAdmFactoryModelEafm.entity.eafmRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
]

export {EmAdmFactoryModelEafm, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
